import { useEffect, useState } from 'react';

const POLL_INTERVAL_MS = 60 * 1000;

// Id do build publicado (null quando não dá para saber: sem rede, arquivo ausente, resposta que não é JSON)
async function fetchDeployedVersion() {
  try {
    const response = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
    if (!response.ok) return null;
    const data = await response.json();
    return data?.version ?? null;
  } catch (error) {
    return null;
  }
}

// Saiu versão nova do portal? O scripts/build.js grava o mesmo id no bundle (REACT_APP_BUILD_ID) e no version.json do
// build; quando o publicado muda, o que está aberto ficou para trás. Consulta a cada minuto e quando a aba volta a ficar
// visível, e para depois de achar. No npm start e nos testes não há id, e não consulta
export function useAppUpdate() {
  const buildId = process.env.REACT_APP_BUILD_ID;
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    if (!buildId || available) return undefined;
    let active = true;

    async function check() {
      const deployed = await fetchDeployedVersion();
      if (active && deployed && deployed !== buildId) setAvailable(true);
    }

    const timer = window.setInterval(check, POLL_INTERVAL_MS);
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVisible);
    check();

    return () => {
      active = false;
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [buildId, available]);

  return available;
}
